import React, { useRef, useState, useEffect, useCallback } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here
import withPasteUpload from "@rpldy/upload-paste";
import Uploady from "@rpldy/uploady";

const viewImg = require("./../assets/img/viewImg.png");
const backBtn = require("./../assets/img/back-btn.svg").default;
const CrossBtn = require("./../assets/img/cross-icon.svg").default;
const logo = require("./../assets/img/logo.svg").default;
const demoImg = require("./../assets/img/demo-img.png");
const companyLogo = require("./../assets/img/company-logo.svg").default;

const CreateForm = () => {
  const navigate = useNavigate();
  const [selectedImages, setSelectedImages] = useState([]);
  const [showViewImg, setShowViewImg] = useState(true);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [showLinkPopup, setShowLinkPopup] = useState(false);
  const [isScrollBottom, setIsScrollBottom] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [dateValue, setDateValue] = useState("");

  const [userData, setUserData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [fileTerms, setFileTerms] = useState(null);
  const [fileName, setFileName] = useState(null);

  const [fileData, setFileData] = useState([]);
  const [userId, setUserId] = useState("");
  const [formName, setFormName] = useState("");
  const [labels, setLabels] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [customerDefault, setCustomerDefault] = useState("");
  const [jobCodeDefault, setJobCodeDefaut] = useState("");
  const [errorMsg, setErrorMsg] = useState();
  const [draggingOver, setDraggingOver] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(true);
  const [imageBoxChecked, setImageBoxChecked] = useState(true);
  const [senderEmail, setSenderEmail] = useState();
  const [senderEmailError, setSenderEmailError] = useState("");
  const [formDate, setFormDate] = useState("");
  const [formKeyEmail, setFormKeyEmail] = useState("");
  const [createFromBtnDis, setCreateFromBtnDis] = useState(false);
  const [submitBtnDis, setSubmitBtnDis] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  const handleDateChange = (event) => {
    setDateValue(event.target.value);
  };

  const handleImageChange = (event) => {
    // const files = event.target.files;
    // const fileArray = Array.from(files);
    // setSelectedImages((prevSelectedImages) => [
    //   ...prevSelectedImages,
    //   ...fileArray,
    // ]);

    event.preventDefault();
    const files = event.target.files;
    const newImages = [...selectedImages];
    for (let i = 0; i < files.length; i++) {
      if (files[i] && isImageFile(files[i])) {
        console.log("normal file:", files[i]);
        newImages.push(files[i]);
        // You can now upload or process the pasted file
        setErrorMsg(null);
      } else {
        setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
        setTimeout(() => {
          setErrorMsg(null);
        }, 2000);
      }
    }
    setSelectedImages(newImages);
    console.log("newImages: ", newImages);
    event.target.value = null;
  };

  const handleRemoveImage = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
  };

  const handleCrossFirstClick = () => {
    setShowViewImg(false);
  };

  const handlePreviewBtnClick = () => {
    setShowPreviewPopup(true);
  };
  const popupBtnClick = () => {
    setShowPreviewPopup(false);
    setShowLinkPopup(false);
    setShowSubmit(true);
  };

  const handleLinkBtnClick = () => {
    setShowLinkPopup(true);
    setShowPreviewPopup(false);
  };

  const signatureRef = useRef();
  const [canvasSize, setCanvasSize] = useState({
    width: 650,
    height: 200,
  });

  const handleClear = () => {
    signatureRef.current.clear();
  };

  const handleSave = () => {
    const signatureData = signatureRef.current.toDataURL();
    // You can now save or use the signatureData as needed.
  };

  const handleScroll = () => {
    const viewContent = document.querySelector(".acknw");
    if (viewContent) {
      const { scrollTop, scrollHeight, clientHeight } = viewContent;
      const isBottom = scrollTop + clientHeight >= scrollHeight - 10; // Adding a small offset
      setIsScrollBottom(isBottom);
    }
  };

  const { fileId } = useParams(); // Get the file name from route params
  const { form_key } = useParams();

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    // Fetch file details using the specific file's name
    fetch(`https://cliqestimatebuilder.com/waiver_admin/files/demo`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let newKey = "Job description and Notes";
        data.data.excel_data[0].push(newKey);
        data.data.excel_data[1].push("");
        console.log(data.data.excel_data);
        setFileDetails(data.data.excel_data); // Update the state with fetched file details
        setFileTerms(data.data.terms);
        setFileName(data.data.title);
        setCustomerDefault(data.data.excel_data[1][4]);
        const dateStr = data.data.excel_data[1][8];
        const date = new Date(dateStr);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-indexed
        const year = date.getFullYear();

        const formattedDate = `${day}/${month}/${year}`;
        setFormDate(formattedDate);

        let tempObj = {};
        data.data.excel_data.length > 0 &&
          data.data.excel_data[0].map((item, index) => {
            if (
              item === "Job code" ||
              item === "Total price" ||
              item === "Assigned to invoice" ||
              item === "Processing service" ||
              item === "Customer" ||
              item === "Last updated by" ||
              item === "Customer PO#" ||
              item === "Metal" ||
              item === "Item SKU" ||
              item === "Order date" ||
              item === "Due Date" ||
              item === "Contact email" ||
              item === "Finger Size" ||
              item === "PLAT Metal Credit" ||
              item === "14K Metal Credit" ||
              item === "18K Metal Credit" ||
              item === "Job description and Notes"
            ) {
              tempObj[index] = true;
            }
          });
        setSelectedCheckboxes(tempObj);
      })
      .catch((error) => {
        console.error("Error fetching file details:", error);
      });

    const handleResize = () => {
      const newCanvasSize = {
        width: window.innerWidth >= 768 ? 650 : "250",
        height: window.innerWidth >= 768 ? 200 : "130",
      };
      setCanvasSize(newCanvasSize);

      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initialize canvas size based on initial window width

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [fileId]);

  const formDataSubmit = () => {
    if (!senderEmail) {
      setSenderEmailError("Invite by email is required.");
      return;
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(senderEmail)) {
      setSenderEmailError("Invite by email is not valid email.");
      return;
    } else {
      setSubmitBtnDis(true);
      setSenderEmailError("");
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      const formData = new FormData();
      formData.append("email", senderEmail);
      formData.append("form_key", formKeyEmail);
      fetch(
        `https://cliqestimatebuilder.com/waiver_admin/forms/update_form_by_email`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${storedUserData.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setSubmitBtnDis(false);
          // Handle the response data as needed
          // For example, you can show a success message or navigate to a new page

          navigate("/after-submitted-form", {
            state: { email: senderEmail, form_key: data.data.form_key },
          });
        })
        .catch((error) => {
          console.error("Error submitting form data:", error);
          setSubmitBtnDis(false);
          // Handle the error, such as displaying an error message
        });
    }
  };

  const formSaveSubmit = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    const formData = new FormData();
    fileDetails[0] &&
      Object.entries(fileDetails[0]).forEach(([label, value]) => {
        if (
          label !== "Job code" &&
          label !== "Customer" &&
          label !== "Total price" &&
          label !== "Contact email" &&
          label !== "Metal" &&
          label !== "Finger Size" &&
          label !== "PLAT Metal Credit" &&
          label !== "14K Metal Credit" &&
          label !== "18K Metal Credit" &&
          document.getElementById(`checkbox-${label}`)?.checked
        ) {
          // selectedLabels.push(value);
          // selectedValues.push(fileDetails[1][label]);
          formData.append("labels[]", value);
          formData.append("input_values[]", fileDetails[1][label]);
        }
      });
    // formData.append("labels[]", selectedLabels);
    // formData.append("input_values[]", selectedValues);
    if (imageBoxChecked) {
      selectedImages.forEach((image, index) => {
        formData.append("images[]", image);
      });
    } else {
    }

    formData.append("form_key", formKeyEmail);
    setCreateFromBtnDis(true);
    fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data as needed
        // For example, you can show a success message or navigate to a new page
        setFormKeyEmail(data.data.form_key);
        handleLinkBtnClick();
        setCreateFromBtnDis(false);
      })
      .catch((error) => {
        console.error("Error submitting form data:", error);
        setCreateFromBtnDis(false);
        // Handle the error, such as displaying an error message
      });
  };

  const formSubmit = async (event) => {
    event.preventDefault();
    formSaveSubmit();

    // const selectedLabels = ["Job code", "Customer", "Total price", "Metal"]; // Include "Job code" and "Customer" by default
    // const selectedValues = [
    //   fileDetails[1][0],
    //   fileDetails[1][4],
    //   fileDetails[1][1],
    //   fileDetails[1][45],
    // ]; // Include their corresponding values
    // const formData = new FormData();
    // selectedLabels.forEach((image, index) => {
    //   formData.append("labels[]", image);
    // });
    // selectedValues.forEach((image, index) => {
    //   formData.append("input_values[]", image);
    // });
    // fileDetails[0] &&
    //   Object.entries(fileDetails[0]).forEach(([label, value]) => {
    //     if (
    //       label !== "Job code" &&
    //       label !== "Customer" &&
    //       label !== "Total price" &&
    //       label !== "Metal" &&
    //       document.getElementById(`checkbox-${label}`).checked
    //     ) {
    //       // selectedLabels.push(value);
    //       // selectedValues.push(fileDetails[1][label]);
    //       formData.append("labels[]", value);
    //       formData.append("input_values[]", fileDetails[1][label]);
    //     }
    //   });

    // // formData.append("labels[]", selectedLabels);
    // // formData.append("input_values[]", selectedValues);
    // selectedImages.forEach((image, index) => {
    //   formData.append("images[]", image);
    // });

    // formDataSubmit();
  };

  const handleFileDetailsChange = (label, newValue) => {
    // Create a copy of the existing file details to avoid mutating the state directly
    const updatedFileDetails = { ...fileDetails };

    // Update the value in the copied file details
    updatedFileDetails[1][label] = newValue;

    // Set the updated file details in the state
    setFileDetails(updatedFileDetails);
  };

  const handleCheckboxChange = (key) => {
    setSelectedCheckboxes((prevSelectedCheckboxes) => ({
      ...prevSelectedCheckboxes,
      [key]: !prevSelectedCheckboxes[key],
    }));
  };

  const handleInputKeyUp = () => {
    const cstmrElement = document.querySelector(".authoLabel");

    if (cstmrElement) {
      const selectedLabels = Object.keys(selectedCheckboxes).filter(
        (key) => selectedCheckboxes[key]
      );

      console.log(fileDetails[0][0]);

      const selectedContent = [...selectedLabels]
        .filter(
          (key) =>
            key !== "0" &&
            key !== "1" &&
            key !== "2" &&
            key !== "3" &&
            key !== "4" &&
            key !== "5" &&
            key !== "6" &&
            key !== "7" &&
            key !== "8" &&
            key !== "9" &&
            key !== "10" &&
            key !== "11" &&
            key !== "12" &&
            key !== "13" &&
            key !== "14" &&
            key !== "15" &&
            key !== "16" &&
            key !== "17" &&
            key !== "18" &&
            key !== "19" &&
            key !== "20" &&
            key !== "21" &&
            key !== "22" &&
            key !== "23" &&
            key !== "24" &&
            key !== "25" &&
            key !== "26" &&
            key !== "27" &&
            key !== "28" &&
            key !== "29" &&
            key !== "30" &&
            key !== "31" &&
            key !== "32" &&
            key !== "33" &&
            key !== "34" &&
            key !== "35" &&
            key !== "36" &&
            key !== "37" &&
            key !== "38" &&
            key !== "39" &&
            key !== "40" &&
            key !== "41" &&
            key !== "42" &&
            key !== "43" &&
            key !== "44" &&
            key !== "45" &&
            key !== "46" &&
            key !== "47" &&
            key !== "48" &&
            key !== "49" &&
            key !== "50" &&
            key !== "51" &&
            key !== "52" &&
            key !== "53" &&
            key !== "54" &&
            key !== "56" &&
            key !== "57" &&
            key !== "58" &&
            key !== "59" &&
            key !== "60" &&
            key !== "61" &&
            key !== "62" &&
            key !== "63" &&
            key !== "64"
        )
        .map(
          (key) =>
            `<li><h3>${fileDetails[0][key]}</h3>${fileDetails[1][key]}</li>`
        )
        .join("");

      cstmrElement.insertAdjacentHTML("afterend", selectedContent);
    }
  };

  const isImageFile = (file) => {
    // Define accepted image MIME types
    const acceptedImageTypes = ["image/jpeg", "image/png"];

    // Check if the file's MIME type is in the accepted types array
    return acceptedImageTypes.includes(file.type);
  };

  const PasteArea = withPasteUpload(({ onPasteUpload }) => {
    return (
      <div
        style={{
          width: "400px",
          height: "400px",
          border: "2px dashed #000", // Add a dashed border for visualization
          display: "none",
          alignItems: "center",
          justifyContent: "center",
        }}
        onPaste={onPasteUpload}
      >
        Paste file here to upload
      </div>
    );
  });

  const onPasteUpload = useCallback((event) => {
    event.preventDefault(); // Prevent the default paste behavior
    const clipboardData = event.clipboardData || window.clipboardData;
    const newImages = [];
    if (clipboardData && clipboardData.items) {
      for (let i = 0; i < clipboardData.items.length; i++) {
        const item = clipboardData.items[i];
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file && isImageFile(file)) {
            console.log("Pasted file:", file);
            newImages.push(file);
            // You can now upload or process the pasted file
            // setErrorMsg(null);
          } else {
            setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
            setTimeout(() => {
              setErrorMsg(null);
            }, 2000);
          }
        }
      }
    }

    setSelectedImages((prevImages) => [...prevImages, ...newImages]); // Merge old and new images
    console.log("newImages: ", newImages);
    event.target.value = null;
  }, []);

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const newImages = [...selectedImages];
    for (let i = 0; i < files.length; i++) {
      if (files[i] && isImageFile(files[i])) {
        console.log("Pasted file:", files[i]);
        newImages.push(files[i]);
        // You can now upload or process the pasted file
        setErrorMsg(null);
      } else {
        setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
        setTimeout(() => {
          setErrorMsg(null);
        }, 2000);
      }
    }
    setSelectedImages(newImages);
    setDraggingOver(false);
    setDragEnabled(false);
    console.log("newImages: ", newImages);
    e.target.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragLeave = () => {
    setDraggingOver(false);
  };

  useEffect(() => {
    const acceptableTag = document.querySelector(".imgBox");
    acceptableTag.addEventListener("paste", onPasteUpload);

    return () => {
      // Remove the paste event listener when the component unmounts
      acceptableTag.removeEventListener("paste", onPasteUpload);
    };
  }, [onPasteUpload]);

  useEffect(() => {
    // Update .cstmr content when the preview popup is open
    if (showPreviewPopup) {
      handleInputKeyUp();
    }
  }, [showPreviewPopup]);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewOne">
            <div className="viewOneLeft">
              <Link to="/search-result">
                <img src={backBtn} alt="image" />
              </Link>
              <h3>
                Create Form <span>{fileName}</span>
              </h3>
            </div>
            <div className="viewOneRight">
              <Link
                to=""
                className="previewBtn"
                onClick={handlePreviewBtnClick}
              >
                Preview
              </Link>
            </div>
          </div>
          <div className="viewBox">
            <form onSubmit={formSubmit}>
              <ul className="previewOne crteForm">
                <>
                  {showSubmit &&
                    (createFromBtnDis ? (
                      <button type="button" disabled className="createFrm">
                        Please wait...
                      </button>
                    ) : (
                      <button type="submit" className="createFrm">
                        Create Form
                      </button>
                    ))}
                </>

                {fileDetails &&
                  fileDetails[0] &&
                  Object.entries(fileDetails[0]).map(([key, value]) =>
                    value === "Job code" ||
                    value === "Total price" ||
                    value === "Customer" ||
                    value === "Customer PO#" ||
                    value === "Contact email" ||
                    value === "Finger Size" ||
                    value === "Metal" ||
                    value === "PLAT Metal Credit" ||
                    value === "14K Metal Credit" ||
                    value === "18K Metal Credit" ||
                    value === "Job description and Notes" ? (
                      <li key={key}>
                        <div className="inCkeck">
                          <>
                            <input
                              type="checkbox"
                              id={`checkbox-${key}`}
                              checked={selectedCheckboxes[key]}
                              onChange={() => handleCheckboxChange(key)}
                            />
                            <label>{value}:</label>
                          </>
                        </div>
                        {value !== "Job description and Notes" ? (
                          <span>
                            <input
                              type="text"
                              value={fileDetails[1][key]}
                              onChange={(event) =>
                                handleFileDetailsChange(key, event.target.value)
                              }
                              onKeyUp={handleInputKeyUp}
                            />
                          </span>
                        ) : null}
                        {value === "Job description and Notes" ? (
                          <span>
                            <textarea
                              value={fileDetails[1][key]}
                              disabled={
                                value === "Job code" ||
                                value === "Customer PO#" ||
                                value === "Total price" ||
                                value === "Finger Size" ||
                                value === "Metal" ||
                                value === "PLAT Metal Credit" ||
                                value === "14K Metal Credit" ||
                                value === "18K Metal Credit" ||
                                value === "Customer"
                              }
                              onChange={(event) =>
                                handleFileDetailsChange(key, event.target.value)
                              }
                              onKeyUp={handleInputKeyUp}
                            />
                          </span>
                        ) : null}
                      </li>
                    ) : null
                  )}
                <li>
                  <div className="inCkeck">
                    <input
                      type="checkbox"
                      checked={imageBoxChecked}
                      onChange={(e) => setImageBoxChecked(e.target.checked)}
                    />
                    <label>Image:</label>
                  </div>
                  <div
                    className="imgBox"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                  >
                    {selectedImages.length > 0 && (
                      <div className="image-preview">
                        {selectedImages.map((image, index) => (
                          <div key={index} className="image-container">
                            <img
                              src={URL.createObjectURL(image)}
                              alt={`Uploaded ${index + 1}`}
                              className="upImg"
                            />
                            <button
                              className="remove-btn"
                              onClick={() => handleRemoveImage(index)}
                            >
                              <img src={CrossBtn} alt="Remove" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                    <div className="upload-btn-wrapper">
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleImageChange}
                      />
                    </div>
                    <Uploady>
                      <PasteArea />
                    </Uploady>
                  </div>
                  {errorMsg ? (
                    <span className="msgBrse errMsgClr">{errorMsg}</span>
                  ) : null}

                  <p className="msgBrse">
                    *Browse file or Drag and drop multiple images here
                  </p>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>

      {showPreviewPopup && (
        <div className="previewPopup">
          <div className="previewPopupInner">
            <div className="scrollInner">
              <button className="popupCloseBtn" onClick={() => popupBtnClick()}>
                <img src={CrossBtn} alt="Remove" />
              </button>
              <div className="lftPop">
                <img src={logo} alt="image" />
              </div>
              <div className="rgtPop">
                <h3>
                  <img src={companyLogo} alt="image" />
                </h3>
                <p>211 N. 13th Street, 9th Floor, Philadelphia,PA 19107, USA</p>
                <p>
                  <span>p:</span> 800.765.7111 <span>E:</span>
                  info@cliqjewelry.com
                </p>
              </div>

              <div className="jobDtls">
                <h3>
                  {fileDetails &&
                    fileDetails[0] &&
                    Object.entries(fileDetails[0]).map(([key, value]) =>
                      value === "Job code" ? (
                        <div key={key}>
                          <span>Job:</span> {fileDetails[1][key]}
                        </div>
                      ) : null
                    )}
                </h3>
                <h3>
                  <span>Date:</span>
                </h3>
              </div>

              <div className="prvwForm">
                <ul className="cstmr popupCstr">
                  <li>
                    {fileDetails &&
                      fileDetails[0] &&
                      Object.entries(fileDetails[0]).map(([key, value]) =>
                        value === "Customer" ? (
                          <div key={key}>
                            <h3>Customer Name:</h3> {fileDetails[1][key]}
                          </div>
                        ) : null
                      )}
                  </li>
                  <li>
                    <h3>Insured Value:</h3>
                    <input
                      type="text"
                      placeholder="Enter value (in dollars)"
                      disabled
                    />
                  </li>

                  <li>
                    <h3>Authorized Representative:</h3>
                    <input
                      type="text"
                      placeholder=""
                      className="inputTxt"
                      disabled
                    />
                  </li>
                  <li className="authoLabel">
                    {fileDetails &&
                      fileDetails[0] &&
                      Object.entries(fileDetails[0]).map(([key, value]) =>
                        value === "Customer PO#" ? (
                          <div key={key}>
                            <h3>Customer PO#</h3> {fileDetails[1][key]}
                          </div>
                        ) : null
                      )}
                  </li>

                  {imageBoxChecked ? (
                    <li className="fulWid previewPopupImg">
                      <h3>Job Images:</h3>
                      <div className="image-preview">
                        {selectedImages.map((image, index) => (
                          <img
                            key={index}
                            src={URL.createObjectURL(image)}
                            alt={`Uploaded ${index + 1}`}
                            className="viewImg"
                          />
                        ))}
                      </div>
                    </li>
                  ) : null}
                  <li className="HdnBck txtWid">
                    <h4>Metal</h4>
                  </li>
                  <li className="HdnBck txtWid2">
                    <h4>Finger Size</h4>
                  </li>

                  <li className="txtWid">
                    {fileDetails &&
                      fileDetails[0] &&
                      Object.entries(fileDetails[0]).map(([key, value]) =>
                        value === "Metal" ? (
                          <div key={key}>{fileDetails[1][key]}</div>
                        ) : null
                      )}
                  </li>
                  <li className="txtWid2">
                    {fileDetails &&
                      fileDetails[0] &&
                      Object.entries(fileDetails[0]).map(([key, value]) =>
                        value === "Finger Size" ? (
                          <div key={key}>{fileDetails[1][key]}</div>
                        ) : null
                      )}
                  </li>
                </ul>
                <div className="cstmr"></div>
                <ul className="prctable">
                  <li className="ttlTbl">
                    <h3>
                      Total price:{" "}
                      <strong>
                        {fileDetails &&
                          fileDetails[0] &&
                          Object.entries(fileDetails[0]).map(([key, value]) =>
                            value === "Total price" ? (
                              <div key={key}>{fileDetails[1][key]}</div>
                            ) : null
                          )}
                      </strong>
                    </h3>
                  </li>
                </ul>
              </div>

              <div className="sigName">
                <div className="lftSig">
                  <div className="dteHidden">
                    <label>Authorized Representative:</label>
                    <input type="text" placeholder="" disabled />
                    <input type="text" placeholder="Date" disabled />
                  </div>
                  <h4>
                    {fileDetails &&
                      fileDetails[0] &&
                      Object.entries(fileDetails[0]).map(([key, value]) =>
                        value === "Customer" ? (
                          <div key={key}>and {fileDetails[1][key]}</div>
                        ) : null
                      )}
                  </h4>
                </div>
                <div className="rgtSig">
                  <h3>
                    {fileDetails &&
                      fileDetails[0] &&
                      Object.entries(fileDetails[0]).map(([key, value]) =>
                        value === "Job code" ? (
                          <div key={key}>
                            <span>Job:</span> {fileDetails[1][key]}
                          </div>
                        ) : null
                      )}
                  </h3>
                </div>
              </div>

              <div className="acknw" onScroll={handleScroll}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: fileTerms,
                  }}
                />
              </div>

              <ul className="popFrm">
                <li>
                  <input
                    type="checkbox"
                    id="enableCheckbox"
                    disabled={!isScrollBottom}
                  />{" "}
                  I accept
                </li>
                <li>
                  <input type="checkbox" disabled={!isScrollBottom} /> I do not
                  accept these terms, please return my job, with no work
                  completed
                </li>
                <li>
                  <span>
                    <input type="checkbox" disabled={!isScrollBottom} /> Please
                    return all my scrap metal
                  </span>
                  <span>
                    <input type="checkbox" disabled={!isScrollBottom} />
                    Please retain all scrap at rates listed:
                    <p className="mtlPara">
                      {fileDetails &&
                        fileDetails[0] &&
                        Object.entries(fileDetails[0]).map(([key, value]) =>
                          value === "PLAT Metal Credit" ? (
                            <div key={key}>
                              PLAT Metal Credit : {fileDetails[1][key]}
                            </div>
                          ) : null
                        )}
                    </p>
                    <p className="mtlPara">
                      {fileDetails &&
                        fileDetails[0] &&
                        Object.entries(fileDetails[0]).map(([key, value]) =>
                          value === "14K Metal Credit" ? (
                            <div key={key}>
                              14K Metal Credit : {fileDetails[1][key]}
                            </div>
                          ) : null
                        )}
                    </p>
                    <p className="mtlPara">
                      {fileDetails &&
                        fileDetails[0] &&
                        Object.entries(fileDetails[0]).map(([key, value]) =>
                          value === "18K Metal Credit" ? (
                            <div key={key}>
                              18K Metal Credit : : {fileDetails[1][key]}
                            </div>
                          ) : null
                        )}
                    </p>
                  </span>
                </li>
              </ul>

              <div className="signBox">
                <h3>Signor name:</h3>
                <div className="signInner">
                  <div>
                    {/* <SignatureCanvas
                      ref={signatureRef}
                      canvasProps={{
                        width: canvasSize.width,
                        height: canvasSize.height,
                        className: "signatureCanvas",
                      }}
                    /> */}
                    <button onClick={handleClear}>Clear</button>
                    <button onClick={handleSave}>Save</button>
                  </div>
                </div>

                <h4>Customer signature</h4>

                <button className="continueBtn">Submit</button>
                <Link className="cntMe">
                  Have someone contact me to discuss details further
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLinkPopup && (
        <div className="previewPopup">
          <div className="drctLinkPopupInner">
            <button className="popupCloseBtn" onClick={() => popupBtnClick()}>
              <img src={CrossBtn} alt="Remove" />
            </button>
            <div className="drctLink">
              <h3>DIRECT LINK OF YOUR FORM</h3>
              <p>
                Your form is securely published and ready to use at this Email
                address.
              </p>
            </div>

            <div className="emailSec">
              <label>INVITE BY EMAIL</label>
              <input
                type="email"
                placeholder="Enter Recipient email id"
                onChange={(e) => setSenderEmail(e.target.value)}
              />
              {submitBtnDis ? (
                <button disabled type="submit">
                  <Link>Please wait...</Link>
                  {/* <Link to="/after-submitted-form">Submit</Link>/ */}
                </button>
              ) : (
                <button type="submit" onClick={() => formDataSubmit()}>
                  <Link>Submit</Link>
                  {/* <Link to="/after-submitted-form">Submit</Link>/ */}
                </button>
              )}

              {senderEmailError ? (
                <span className="lgnStatus mrhnTp">{senderEmailError}</span>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateForm;
